<template lang="html">
    <div class="page">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Weekly Availability</h2>
                <ul class="links">
                    <li>
                        <router-link class="cancel" :to="{ name: 'proLessonDiary' }"
                            ><x-icon class="icon"
                        /></router-link>
                    </li>
                </ul>
            </header>

            <span class="info">
                Select the day and add the times you want to make available for lesson booking every
                week
            </span>

            <div class="dayPicker">
                <day-item
                    @removeDay="removeActiveDay"
                    v-for="day in form.days"
                    :key="day.day"
                    :day="day"
                />
            </div>

            <empty-placeholder class="mt30 mb0">
                TIP: You can manually overide availability by selecting an individual day(s) on your
                diary
            </empty-placeholder>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";

import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
import { Form } from "vform";
import dayItem from "@/components/Pro/Lessons/day-item";
export default {
    name: "manage-diary",
    components: { EmptyPlaceholder, FadeImage, dayItem, XIcon },
    created() {
        this.getAvailability();
    },
    data() {
        return {
            form: new Form({
                days: [
                    {
                        day: "monday",
                        active: false,
                    },
                    {
                        day: "tuesday",
                        active: false,
                    },
                    {
                        day: "wednesday",
                        active: false,
                    },
                    {
                        day: "thursday",
                        active: false,
                    },
                    {
                        day: "friday",
                        active: false,
                    },
                    {
                        day: "saturday",
                        active: false,
                    },
                    {
                        day: "sunday",
                        active: false,
                    },
                ],
            }),
        };
    },
    methods: {
        removeActiveDay(index) {
            this.form.days[index].active = false;
        },
        getAvailability() {
            this.form.get("/recurring/availability").then((response) => {
                response.data.forEach((availability) => {
                    this.form.days[availability.day].active = true;
                    this.form.days[availability.day].dayIndex = availability.day;

                    console.log(this.form.days[availability.day].dayIndex);
                });
            });
        },
    },
};
</script>

<style lang="scss">
.dayPicker {
    margin-bottom: 20px;
}
</style>
